const data = [
    { id: 1, name: "RECUPERAÇÕES JUDICIAIS", route: "/casos/recuperacoes"},
    { id: 2, name: "FALÊNCIAS", route: "/casos/falencias"},
    { id: 3, name: "LIQUIDAÇÃO JUDICIAL", route: "/casos/liquidacao-judicial"},
    { id: 4, name: "INSOLVÊNCIA CIVIL", route: "/casos/insolvencia-civil"}, 
];
  
export default [...data];